module.exports = __webpack_public_path__ + "static/media/image_part_002.aa7842ba.jpg";